
import {
    KNDATA_OPERATION_ACTION_TYPE
} from '../sagas/knData';

import {
    GET_PROJECT_ACTION_TYPE,
    REFRESH_PROJECT_ACTION_TYPE
} from '../sagas/project';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState
};

export default function createReducer() {
    const loaderReducer = createLoaderReducer(KNDATA_OPERATION_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case REFRESH_PROJECT_ACTION_TYPE:
                return {
                    ...initialState
                };

            case GET_PROJECT_ACTION_TYPE.DEFAULT:
                return {
                    ...initialState
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
